"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./Input.module.css"));
var Input = (function (_super) {
    __extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.handleChange = function (evt) {
        this.value = evt.target.validity.valid ? evt.target.value : this.value;
    };
    Input.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, type = _a.type, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors, pattern = _a.pattern, classNameWrap = _a.classNameWrap, className = _a.className, children = _a.children, onBlur = _a.onBlur;
        this.value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root + " " + className;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (React.createElement("div", { className: classNameWrap },
            React.createElement("input", { className: css, id: id, onChange: function (event) {
                    onChange(id, event.target.value);
                }, type: type, placeholder: placeholder, disabled: disabled, onInput: this.handleChange.bind(this), value: this.value, pattern: pattern, onBlur: onBlur, autoComplete: "none" }),
            children,
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    Input.defaultProps = {
        type: "text",
        errors: {}
    };
    return Input;
}(react_1.Component));
exports.Input = Input;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5wdXQuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0lucHV0L0lucHV0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUUvQix5REFBNEM7QUFnQjVDO0lBQTJCLHlCQUFvQjtJQUEvQzs7SUF5REEsQ0FBQztJQWxERyw0QkFBWSxHQUFaLFVBQWEsR0FBRztRQUNaLElBQUksQ0FBQyxLQUFLLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQTtJQUMxRSxDQUFDO0lBRU0sc0JBQU0sR0FBYjtRQUNVLElBQUEsZUFhUSxFQVpWLFVBQUUsRUFDRix3QkFBUyxFQUNULHNCQUFRLEVBQ1IsY0FBSSxFQUNKLDRCQUFXLEVBQ1gsc0JBQVEsRUFDUixrQkFBTSxFQUNOLG9CQUFPLEVBQ1AsZ0NBQWEsRUFDYix3QkFBUyxFQUNULHNCQUFRLEVBQ1Isa0JBQ1UsQ0FBQTtRQUVkLElBQUksQ0FBQyxLQUFLLEdBQUcsU0FBUyxDQUFDLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtRQUNoQyxJQUFNLEtBQUssR0FBRyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQUE7UUFFeEIsSUFBSSxHQUFHLEdBQU0sTUFBTSxDQUFDLElBQUksU0FBSSxTQUFXLENBQUE7UUFDdkMsSUFBSSxLQUFLLEVBQUU7WUFDUCxHQUFHLEdBQU0sR0FBRyxTQUFJLE1BQU0sQ0FBQyxTQUFXLENBQUE7U0FDckM7UUFFRCxPQUFPLENBQ0gsNkJBQUssU0FBUyxFQUFFLGFBQWE7WUFDekIsK0JBQ0ksU0FBUyxFQUFFLEdBQUcsRUFDZCxFQUFFLEVBQUUsRUFBRSxFQUNOLFFBQVEsRUFBRSxVQUFDLEtBQUs7b0JBQ1osUUFBUSxDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO2dCQUNwQyxDQUFDLEVBQ0QsSUFBSSxFQUFFLElBQUksRUFDVixXQUFXLEVBQUUsV0FBVyxFQUN4QixRQUFRLEVBQUUsUUFBUSxFQUNsQixPQUFPLEVBQUUsSUFBSSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQ3JDLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSyxFQUNqQixPQUFPLEVBQUUsT0FBTyxFQUNoQixNQUFNLEVBQUUsTUFBTSxFQUNkLFlBQVksRUFBRSxNQUFNLEdBQ3RCO1lBQ0QsUUFBUTtZQUNSLEtBQUssSUFBSSwyQkFBRyxTQUFTLEVBQUUsTUFBTSxDQUFDLEtBQUs7Z0JBQUcsS0FBSztvQkFBTSxDQUNoRCxDQUNULENBQUE7SUFDTCxDQUFDO0lBdERhLGtCQUFZLEdBQUc7UUFDekIsSUFBSSxFQUFFLE1BQU07UUFDWixNQUFNLEVBQUUsRUFBRTtLQUNiLENBQUE7SUFvREwsWUFBQztDQUFBLEFBekRELENBQTJCLGlCQUFTLEdBeURuQztBQXpEWSxzQkFBSyJ9